module.exports = __webpack_public_path__ + "img/main.e49787af.png";